module.exports = __webpack_public_path__ + "static/media/work4.7a68116c.jpg";